export const mutationNames = {
  SET_APPCONFIG: 'SET_APPCONFIG',
  SET_RSSFEEDDATA:'SET_RSSFEEDDATA',
  EMULATOR_NAME: 'DEV_SIM',
  SET_DEVICE: 'SET_DEVICE',
  SET_DESIGN_SETTINGS: 'SET_DESIGN_SETTINGS',
  SET_START_PAGE: 'SET_START_PAGE',
  SET_SUBSCRIPTIONS_MODULES: 'SET_SUBSCRIPTIONS_MODULES',
  SET_CONTENT_PAGES: 'SET_CONTENT_PAGES',
  SET_CONTENT_PAGE_PARENT: 'SET_CONTENT_PAGE_PARENT',
  SET_CONTENTPAGESPOSTS: 'SET_CONTENTPAGESPOSTS',
  SET_USERCOMMENT: 'SET_USERCOMMENT',
  UPDATE_USERCOMMENT: 'UPDATE_USERCOMMENT',
  ADD_USERCOMMENT: 'ADD_USERCOMMENT',
  SET_TEAMDATA: 'SET_TEAMDATA',
  SET_TEAMMEMBERS: 'SET_TEAMMEMBERS',
  SET_TEAMMEMBERSPERSONS: 'SET_TEAMMEMBERSPERSONS',
  SET_LANGUAGE: 'SET_LANGUAGE',
  ADD_POSTLIKE: 'ADD_POSTLIKE',
  ADD_IMAGELIKE: 'ADD_IMAGELIKE',
  ADD_STREAM: 'ADD_STREAM',
  ADD_STREAMLIKE: 'ADD_STREAMLIKE',
  SET_ACTIVE_MODULE: 'SET_ACTIVE_MODULE',
  UPDATE_STREAM: 'UPDATE_STREAM',
  UPDATE_TEAMPRESON: 'UPDATE_TEAMPRESON',
  UPDATE_TEAMPARENT: 'UPDATE_TEAMPARENT',
  UPDATE_CONTENTPAGEPARENT: 'UPDATE_CONTENTPAGEPARENT',
  UPDATE_CONTENTPAGES: 'UPDATE_CONTENTPAGES',
  SET_POI_TAB: 'SET_POI_TAB',
  CREATE_NEW_CONTENT_PAGE: 'CREATE_NEW_CONTENT_PAGE',
  UPDATE_NEW_CONTENT_PAGE: 'UPDATE_NEW_CONTENT_PAGE',
  CLEAR_CONTENT_EDITING_DATA: 'CLEAR_CONTENT_EDITING_DATA',
  CANCEL_CONTENT_PAGE_EDITING: 'CANCEL_CONTENT_PAGE_EDITING',
  SET_SELECTED_CONTENT_TAB: 'SET_SELECTED_CONTENT_TAB',
  SET_IMAGEGALLERIE: 'SET_IMAGEGALLERIE',
  SET_IMAGE_GALLERIE_PARENT: 'SET_IMAGE_GALLERIE_PARENT',
  SET_IMAGE_GALLERIE_ALBUMS: 'SET_IMAGE_GALLERIE_ALBUMS',
  CREATE_NEW_IMAGE_GALLERIE_ALBUM: 'CREATE_NEW_IMAGE_GALLERIE_ALBUM',
  UPDATE_NEW_IMAGE_GALLERIE_ALBUM: 'UPDATE_NEW_IMAGE_GALLERIE_ALBUM',
  CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA: 'CLEAR_IMAGE_GALLERIE_ALBUM_EDITING_DATA',
  CANCEL_IMAGE_GALLERIE_ALBUM_EDITING: 'CANCEL_IMAGE_GALLERIE_ALBUM_EDITING',
  SET_SELECTED_ALBUM_TAB: 'SET_SELECTED_ALBUM_TAB',
  SET_RESOURCE: 'SET_RESOURCE',
  SET_FORM: 'SET_FORM',
  SET_FORMDATA: 'SET_FORMDATA',
  SET_FORMFIELDS: 'SET_FORMFIELDS',
  SET_MODULE_DATA: 'SET_MODULE_DATA',
  SHOW_APPPREVIEWER_LINK: 'SHOW_APPPREVIEWER_LINK',
  UPDATE_AUDIO_PLAYER: 'UPDATE_AUDIO_PLAYER',
  UPDATE_AUDIO_PLAYER_INFO: 'UPDATE_AUDIO_PLAYER_INFO',
  UPDATE_VIDEO_PLAYER: 'UPDATE_VIDEO_PLAYER',
  UPDATE_RSSFEEDDATA: 'UPDATE_RSSFEEDDATA',
  SET_RSSFEEDLIST: 'SET_RSSFEEDLIST',
  // SET_FACEBOOKPAGEVIDEO:'SET_FACEBOOKPAGEVIDEO' ,
  // SET_FACEBOOKCOVER:'SET_FACEBOOKCOVER',
  // SET_FACEBOOKPOSTS:'SET_FACEBOOKPOSTS',
  // SET_FACEBOOKPAGEDP:'SET_FACEBOOKPAGEDP',
  // SET_FACEBOOKDATA:'SET_FACEBOOKDATA',
  // SET_FACEBOOKPOSTDATA:'SET_FACEBOOKPOSTDATA',
  // SET_FACEBOOKPOSTSCURSOR:'SET_FACEBOOKPOSTSCURSOR' ,
  // SET_FACEBOOKPOSTDATALENGTH:'SET_FACEBOOKPOSTDATALENGTH' ,
  // SET_FACEBOOKPOSTCOMMENTDATA: 'SET_FACEBOOKPOSTCOMMENTDATA',
  // SET_FACEBOOKCOMMENTPAGINGDATA: 'SET_FACEBOOKCOMMENTPAGINGDATA',
  // SET_FACEBOOKERROR: 'SET_FACEBOOKERROR',
  // SET_POSTFLAG:'SET_POSTFLAG',
  // SET_PRELOADER:'SET_PRELOADER',
  // UPDATE_FACEBOOK: 'UPDATE_FACEBOOK',
  SET_YOUTUBEDATA: 'SET_YOUTUBEDATA',
  SET__YOUTUBEPAGEVIDEO: 'SET__YOUTUBEPAGEVIDEO',
  SET__YOUTUBECOMMENTS: 'SET__YOUTUBECOMMENTS',
  SET__YOUTUBECHANNELDATA: 'SET__YOUTUBECHANNELDATA',
  SET__YOUTUBENEXTPAGECOMMENTS: 'SET__YOUTUBENEXTPAGECOMMENTS',
  SET__YOUTUBEVIDEOLIST: 'SET__YOUTUBEVIDEOLIST',
  SET__YOUTUBEVIDEOSTATIC: 'SET__YOUTUBEVIDEOSTATIC',
  UPDATE_YOUTUBE: 'UPDATE_YOUTUBE',
  SET_ACTIVECATEGORY:'SET_ACTIVECATEGORY',
  SET_ACTIVE_ALBUM_CATEGORY: 'SET_ACTIVE_ALBUM_CATEGORY',
  SET_ACTIVE_SUBSCRIPTION_MODULE_ID:'SET_ACTIVE_SUBSCRIPTION_MODULE_ID',
  SET_WEBSITE: 'SET_WEBSITE',
  UPDATE_WEBSITE: 'UPDATE_WEBSITE',
  SET_ACTIVESM:'SET_ACTIVESM',
  UPDATE_USERINFO:'UPDATE_USERINFO',
  SET_CONNECTION:'SET_CONNECTION',
  SET_ChannelmsgCount:'SET_ChannelmsgCount',
  SET_Istypingusers:'SET_Istypingusers',
  SET_CHAT:'SET_CHAT',
  SET_CHAT_PARENT: 'SET_CHAT_PARENT',
  SET_CHAT_CHANNELS: 'SET_CHAT_CHANNELS',
  SET_CHAT_USER: 'SET_CHAT_USER',
  UPDATE_CHAT_USER_INFO: 'UPDATE_CHAT_USER_INFO',
  SET_CHAT_CONNECTION: 'SET_CHAT_CONNECTION',
  SET_CHAT_CONNECTIONS: 'SET_CHAT_CONNECTIONS',
  SET_CHAT_HISTORY: 'SET_CHAT_HISTORY',
  SET_CHANNEL_MESSAGE_COUNT: 'SET_CHANNEL_MESSAGE_COUNT',
  SET_TYPING_USERS: 'SET_TYPING_USERS',
  SET_MESSAGE_NODE: 'SET_MESSAGE_NODE',
  SET_ACTIVE_CHANNEL_ID: 'SET_ACTIVE_CHANNEL_ID',
  UPDATE_CHAT_MODULE_INFO: 'UPDATE_CHAT_MODULE_INFO',
  UPDATE_CHAT_CHANNEL: 'UPDATE_CHAT_CHANNEL',
  CLEAR_CHAT_CHANNEL_EDITING_DATA: 'CLEAR_CHAT_CHANNEL_EDITING_DATA',
  CREATE_NEW_CHAT_CHANNEL: 'CREATE_NEW_CHAT_CHANNEL',
  UPDATE_NEW_CHAT_CHANNEL: 'UPDATE_NEW_CHAT_CHANNEL',
  CANCEL_CHAT_CHANNEL_EDITING: 'CANCEL_CHAT_CHANNEL_EDITING',
  RESET_RECONNECTING_FLAG: 'RESET_RECONNECTING_FLAG',
  SET_TWITTERDATA: 'SET_TWITTERDATA',
  SET_TWITTERUSERDETAIL: 'SET_TWITTERUSERDETAIL',
  SET_TWITTERMEDIADETAIL: 'SET_TWITTERMEDIADETAIL',
  UPDATE_TWITTERDATA: 'UPDATE_TWITTERDATA',  
  SET_INSTAGRAM: 'SET_INSTAGRAM',
  SET_INSTAGRAMUSERDETAIL: 'SET_INSTAGRAMUSERDETAIL',
  SET_INSTAGRAMMEDIADETAIL: 'SET_INSTAGRAMMEDIADETAIL',
  SET_INSTAGRAMCOMMENTDETAIL: 'SET_INSTAGRAMCOMMENTDETAIL',
  SETRESET_SELECTED_TAB_ID: 'SETRESET_SELECTED_TAB_ID',
  SET_TWITTERVIDEOARRAY: 'SET_TWITTERVIDEOARRAY',
  SET_INSTAGRAMVIDEOARRAY: 'SET_INSTAGRAMVIDEOARRAY',
  SET_INSTAGRAMACTIVEPOST:'SET_INSTAGRAMACTIVEPOST',
  // SET_POPUPVALUE: 'SET_POPUPVALUE',
  UPDATE_INSTAGRAM: 'UPDATE_INSTAGRAM',
  SET_FACEBOOK: 'SET_FACEBOOK',
  UPDATE_FACEBOOK: 'UPDATE_FACEBOOK',
  SET_DEVSIM_LOADED: 'SET_DEVSIM_LOADED',
  SET_CUSTOMCODE: 'SET_CUSTOMCODE',
  UPDATE_CUSTOMCODE: 'UPDATE_CUSTOMCODE',
  SET_PDFDATA:'SET_PDFDATA',
  SET_PDFMODULEINFO:'SET_PDFMODULEINFO',
  UPDATE_PDFMODULEINFO:'UPDATE_PDFMODULEINFO',
  UPDATE_PDFDOCLIST: 'UPDATE_PDFDOCLIST'
}



// WEBPACK FOOTER //
// ./src/store/storeKeysettings.js